
import React, { useRef } from "react";
import "./Attach.css";
import deleteicon from '../../assets/delete-transformed.png'
import { IoMdAdd } from "react-icons/io";
import { FaRegFile } from "react-icons/fa6";
const AttachmentGrid = ({ attachments = [], onDocClick, onFileSelect, onDelete }) => {

  const fileInputRef = useRef(null);

  const handleAddClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && onFileSelect) {
      onFileSelect(file);
    }
  };

  return (
    <div className="attachmentSection">
      <p className="attachTitle">Attachments</p>

      <div className="row" style={{ width: "100%", height:"30vh", overflowY:"auto", paddingBottom:"20vh" , scrollbarWidth:"none"}}>
        
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />

        <div
          className="col-md-4"
          style={{
            padding: "10px 5px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            className="addAttachment"
            onClick={handleAddClick}
            style={{
              cursor: "pointer",
              height: "50px",
              backgroundColor:"#eee",
              width: "50px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "30px",
              borderRadius: "50%"
            }}
          >
           <IoMdAdd />
          </div>
        </div>

       
        {attachments.map((doc) => (
          <div
            className="col-md-4"
            key={doc.attachmentid}
            style={{
              padding: "10px 5px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="docdivvatt" style={{ cursor: "pointer", position:"relative" }}>
              <div
  style={{
    position: "absolute",
    bottom:"2px",
    right: "2px",
    color: "white",
    fontSize: "14px",
    cursor: "pointer",
    backgroundColor: "red",
    zIndex: 10,
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.4)"
  }}
>
  <img
    onClick={(e) => {
      e.stopPropagation();
      onDelete?.(doc);
    }}
    src={deleteicon}
    style={{
      width: "12px",
      filter: "invert(1)"
    }}
  />
</div>
          
              <div className="mainatt" onClick={() => onDocClick?.(doc)}>
               <div style={{display:"flex", gap:"10px" ,alignContent:"center"}}>
               <div className="fileIconWrapper">
  <FaRegFile className="fileIcon" />
</div>
                
             <div className="">
  <span className="docnameatt " style={{color:"#374151"}} title={doc.filename}>
    {doc.filename?.length > 8
      ? doc.filename.substring(0, 8) + "..."
      : doc.filename}
  </span>
</div>
                </div>

              </div>


            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default AttachmentGrid;

// import React, { useRef } from "react";
// import FileIcon from "../../utility/Attach_doc/file.png";
// import "./Attach.css";
// import deleteicon from '../../assets/delete-transformed.png'
// import { IoMdAdd } from "react-icons/io";
// const AttachmentGrid = ({ attachments = [], onDocClick, onFileSelect, onDelete }) => {

//   const fileInputRef = useRef(null);

//   const handleAddClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && onFileSelect) {
//       onFileSelect(file);
//     }
//   };

//   return (
//     <div className="attachmentSection">
//       <p className="attachTitle">Attachments</p>

//       <div className="row" style={{ width: "100%", height:"30vh", overflowY:"auto", paddingBottom:"20vh" , scrollbarWidth:"none"}}>
        
//         <input
//           type="file"
//           ref={fileInputRef}
//           style={{ display: "none" }}
//           onChange={handleFileChange}
//         />

//         <div
//           className="col-md-4"
//           style={{
//             padding: "10px 5px",
//             display: "flex",
//             justifyContent: "center",
//           }}
//         >
//           <div
//             className="addAttachment"
//             onClick={handleAddClick}
//             style={{
//               cursor: "pointer",
//               height: "50px",
//               backgroundColor:"#eee",
//               width: "50px",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               fontSize: "30px",
//               borderRadius: "50%"
//             }}
//           >
//            <IoMdAdd />
//           </div>
//         </div>

       
//         {attachments.map((doc) => (
//           <div
//             className="col-md-4"
//             key={doc.attachmentid}
//             style={{
//               padding: "10px 5px",
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <div className="docdivvatt" style={{ cursor: "pointer", position:"relative" }}>
//               <div
//   style={{
//     position: "absolute",
//     top: "5px",
//     right: "20px",
//     color: "white",
//     fontSize: "14px",
//     cursor: "pointer",
//     backgroundColor: "red",
//     zIndex: 10,
//     borderRadius: "50%",
//     width: "25px",
//     height: "25px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.4)"
//   }}
// >
//   <img
//     onClick={(e) => {
//       e.stopPropagation();
//       onDelete?.(doc);
//     }}
//     src={deleteicon}
//     style={{
//       width: "15px",
//       filter: "invert(1)"
//     }}
//   />
// </div>
            

//               <div className="mainatt" onClick={() => onDocClick?.(doc)}>
//                 <img src={FileIcon} alt="" />

//                 <span style={{ fontSize: "10px" }}>
//                   {doc.extension}
//                 </span>
//               </div>

//               <div className="bottom">
//                 <span className="docnameatt">{doc.filename}</span>
//               </div>

//             </div>
//           </div>
//         ))}

//       </div>
//     </div>
//   );
// };

// export default AttachmentGrid;